<template>
  <div id="app">
    <div>
      <el-form style="height: 40px" :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-input
            size="small"
            v-model="courseName"
            placeholder="请输入课程名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="feelingList"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button @click="batchGo" size="small" type="primary"
            >批量通过</el-button
          >
          <el-button @click="batchNo" size="small" type="danger"
            >批量不通过</el-button
          >
        </el-form-item>
      </el-form>
      <el-tabs v-model="replyStatus" @tab-click="handleClick">
        <el-tab-pane label="未审核" name="0"> </el-tab-pane>
        <el-tab-pane label="已审核" name="1"></el-tab-pane>
        <el-tab-pane label="驳回" name="2"></el-tab-pane>
      </el-tabs>
      <el-table
        :row-style="{ height: '48px' }"
        :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
        :data="feelingData"
        stripe
        border
        style="width: 100%"
        ref="multipleTable"
        @select="handleSelectionChange"
        @select-all="handleSelectionAll"
      >
        <el-table-column align="center" type="selection" width="55">
        </el-table-column>
        <el-table-column prop="feelingContent" label="讨论内容" align="center">
        </el-table-column>
        <el-table-column prop="userName" label="发布人" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="发表时间" align="center">
        </el-table-column>
        <el-table-column prop="courseName" label="课程名称" align="center">
        </el-table-column>
        <el-table-column prop="beginTime" label="直播时间" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              @click="feelingBatchReview(1, scope.row.feelingId)"
              size="small"
              type="text"
              v-if="replyStatus == 0 || replyStatus == 2"
              >通过</el-button
            >
            <el-button
              @click="feelingBatchReview(2, scope.row.feelingId)"
              style="color: #fd6666"
              size="small"
              type="text"
              v-if="replyStatus == 0 || replyStatus == 1"
              >不通过</el-button
            >
            <el-button
              @click="feelingSetTop(scope.row)"
              size="small"
              type="text"
              v-if="replyStatus == 1"
              >{{ scope.row.isTop == 0 ? "置顶" : "取消置顶" }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 15px"
        background
        layout="total,sizes, prev, pager, next, jumper"
        @current-change="currentChange"
        @size-change="handleSizeChange"
        :total="totalCount"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import * as homeApi from "@/api/home";
export default {
  data() {
    return {
      feelingData: [],
      replyStatus: "0",
      curPage: 1,
      pageSize: 10,
      courseName: "",
      feelIds: [],
      totalCount: 0,
      groupId: localStorage.getItem("groupId"),
    };
  },
  created() {
    this.feelingList();
  },
  mounted() {},
  methods: {
    //   听课感受-获取听课感受
    feelingList() {
      let params = {
        replyStatus: this.replyStatus,
        curPage: this.curPage,
        pageSize: this.pageSize,
        courseName: this.courseName,
        groupId: this.groupId,
      };
      homeApi.feelingList(params).then((res) => {
        this.feelingData = res.data.data.dataList;
        this.totalCount = res.data.data.totalCount;
        if (this.feelIds.length !== 0) {
          this.feelIds.forEach((item) => {
            this.feelingData.forEach((items) => {
              if (items.feelingId == item) {
                setTimeout(() => {
                  this.$refs.multipleTable.toggleRowSelection(items);
                });
              }
            });
          });
        }
      });
    },
    // tab栏点击事件
    handleClick() {
      this.curPage = 1
      this.feelIds = [];
      this.courseName = "";
      this.feelingList();
    },
    // 批量通过
    batchGo() {
      if (this.replyStatus == 1) {
        this.$message.error("禁止通过操作！");
        return false;
      }
      if (this.feelIds.length == 0) {
        this.$message.error("请选择内容后再操作！");
        return false;
      }
      this.$confirm("你确定要批量通过这些记录?", "通过", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.feelingBatchReview(1);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 批量不通过
    batchNo() {
      if (this.replyStatus == 2) {
        this.$message.error("禁止不通过操作！");
        return false;
      }
      if (this.feelIds.length == 0) {
        this.$message.error("请选择内容后再操作！");
        return false;
      }
      this.$confirm("你确定要批量不通过这些记录?", "不通过", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.feelingBatchReview(2);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 批量审核通过/不通过
    feelingBatchReview(flag, id = -1) {
      let arr = [id];
      let feelRe = [];
      if (id !== -1) {
        feelRe = arr;
      } else {
        feelRe = this.feelIds;
      }
      let params = {
        feelingIds: feelRe,
        replyStatus: flag,
      };
      homeApi.feelingBatchReview(params).then((res) => {
        if (res.data.code == 0) {
          (this.curPage = 1), this.feelingList();
        }
      });
    },
    // 资源单选
    handleSelectionChange(val, row) {
      let idx = this.feelIds.indexOf(row.feelingId);
      if (idx == -1) {
        this.feelIds.push(row.feelingId);
      } else {
        this.feelIds.splice(idx, 1);
      }
    },
    // 资源全选
    handleSelectionAll(val) {
      if (val.length == 0) {
        this.feelingData.forEach((item, index) => {
          let idx = this.feelIds.indexOf(item.feelingId);
          if (idx !== -1) {
            this.feelIds.splice(idx, 1);
          }
        });
      } else {
        val.forEach((item) => {
          let idx = this.feelIds.indexOf(item.feelingId);
          if (idx == -1) {
            this.feelIds.push(item.feelingId);
          }
        });
      }
    },
    // 设置置顶
    feelingSetTop(item) {
      let params = {
        feelingId: item.feelingId,
        isTop: item.isTop == 0 ? 1 : 0,
      };
      homeApi.feelingSetTop(params).then((res) => {
        if (res.data.code == 0) {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.feelingList()
          return false
        }
        this.$message.error('操作失败')
      });
    },
    // 页码变化
    currentChange(e) {
      this.curPage = e;
      this.feelingList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.feelingList();
    },
  },
};
</script>
<style scoped>
#app {
  max-width: 1660px;
  margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/components/comAudit/comAudit.vue